module.exports = __webpack_public_path__ + "img/term.83ea1d8e.webp";